export default "__VITE_ASSET__C6I1p5ad__"